import { RouterService } from './../router.service';
import { delay } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from '../app.component';
import { SendMessageService } from '../send-message.service';
import { SettingData } from '../setting-data';
import { CookieService } from 'ngx-cookie-service';
import { Message } from '@angular/compiler/src/i18n/i18n_ast';
import { CheckData } from '../check-data';
import { CheckUidService } from '../check-uid.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { HashtutorialComponent } from '../hashtutorial/hashtutorial.component';
import { ControlData } from '../controll-screen/control-data';
import { SettingService } from '../setting.service';
import { CheckIdService } from '../check-id.service';
import { ScrollDispatcher } from '@angular/cdk/scrolling';
import * as $ from "jquery";
// declare var jquery: any;
// declare let $: any;

@Component({
  selector: 'app-setting-screen',
  templateUrl: './setting-screen.component.html',
  styleUrls: ['./setting-screen.component.scss'],
})
export class SettingScreenComponent implements OnInit {
  id: string;
  // tslint:disable-next-line: variable-name
  min_money: number;
  isloop: boolean;
  times: number;
  basetime: number;
  img1: string; // 背景圖片
  img2: string; // 標題LOGO
  img3: string; // 大頭貼
  img4: string; // 斗內圖片
  msg: string;
  settingUrl: string;
  playUrl: string;
  lotteryUrl: string;
  playDonateUrl: string;
  playVideoUrl: string;
  controlUrl: string;
  viwerdonateUrl: string;
  overviewUrl: string;
  opay_HashKey: string;
  opay_HashIV: string;
  opay_shopId: string;

  // tslint:disable-next-line: variable-name
  opay_payment_hash = '24E735ED2BE8A01C6D7DF3002879F719';
  checkState = 0;
  checkIDState = 0;
  youtubeRestrictionLevel = 0;
  constructor(
    private appComponent: AppComponent,
    private activatedRoute: ActivatedRoute,
    public routerService: RouterService,
    private sendMessage: SendMessageService,
    // tslint:disable-next-line: max-line-length
    private cookieService: CookieService,
    private checkUidService: CheckUidService,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private settingService: SettingService,
    private checkIDService: CheckIdService,
    private scrollDispatcher: ScrollDispatcher,
  ) {
    checkIDService.checkStateChange.subscribe((value) => {
      if (value === 1) {
        this.checkIDState = 1;
      } else {
        alert('此ID不存在');
        this.routerService.GoToHomePage();
      }
    });
  }

  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    console.log(window.location.protocol + window.location.host);
    this.controlUrl = 'https://'+ window.location.host + '/control/' + this.id;
    this.playUrl = 'https://'+ window.location.host + '/play/' + this.id;
    this.playDonateUrl = 'https://'+ window.location.host + '/play-donate/' + this.id;
    this.playVideoUrl = 'https://'+ window.location.host + '/play-video/' + this.id;
    this.settingUrl = 'https://'+ window.location.host + '/setting/' + this.id;
    this.viwerdonateUrl = 'https://'+ window.location.host + '/donate/' + this.id;
    this.overviewUrl = 'https://'+ window.location.host + '/overview/' + this.id;
    this.lotteryUrl = 'https://'+ window.location.host + '/lottery/' + this.id;
    this.isloop = false;
    this.appComponent.client.subscribe('check_id/' + this.id + '/res');
    this.appComponent.client.subscribe('setting/' + this.id + '/res');
    if (this.checkID()) {
      this.checkState = 1;
    } else {
      this.goToLogin();
    }
    this.msg = '歡迎抖內實況主';
    this.min_money = 20;
    this.times = 1.5;
    this.basetime = 1;
    this.img1 = 'https://i.imgur.com/MMZ2TvB.jpg';
    this.img2 = 'https://i.imgur.com/MMZ2TvB.jpg';
    this.img3 = 'https://i.imgur.com/MMZ2TvB.jpg';
    this.img4 = 'https://i.imgur.com/MMZ2TvB.jpg';
    this.settingService.settingDataChange.subscribe((settingData) => {
      this.min_money = settingData.min_money;
      this.isloop = settingData.isloop;
      this.times = settingData.times;
      this.basetime = settingData.basetime;
      this.img1 = settingData.img1;
      this.img2 = settingData.img2;
      this.img3 = settingData.img3;
      this.img4 = settingData.img4;
      this.msg = settingData.msg;
      this.opay_payment_hash = settingData.opay_payment_hash;
      // this.youtubeRestrictionLevel = settingData.youtubeRestrictionLevel;
    });
    this.appComponent.client.subscribe('account/' + this.id + '/res');
    const loginData = new ControlData(this.id, 'login');
    const message = JSON.stringify(loginData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'account/' + this.id + '/send'
    );
    this.sendMessage.sendMessage(
      this.appComponent.client,
      JSON.stringify({ id: this.id }),
      'check_id/send'
    );
    this.scrollDispatcher.scrolled().subscribe(() => {
      if ($(window).scrollTop()) {
        $('nav').addClass('black');
      }
      else
      {
        $('nav').removeClass('black');
      }
    });
  }

  isLoop(): void {
    this.isloop = !this.isloop;
  }

  sendSetting(): void {
    const settingData: SettingData = new SettingData(
      this.min_money,
      this.id,
      this.isloop,
      this.times,
      this.basetime,
      this.img1,
      this.img2,
      this.img3,
      this.img4,
      this.msg,
      this.opay_payment_hash,
      50,
      0.5
    );
    const message = JSON.stringify(settingData);
    this.sendMessage.sendMessage(
      this.appComponent.client,
      message,
      'setting/' + this.id + '/send'
    );
  }

  checkID(): boolean {
    console.log(this.cookieService.get('id') + ' : ' + this.id);
    if (!this.cookieService.check('id')) {
      return false;
    }
    if (this.cookieService.get('id') === this.id) {
      return true;
    }
    return false;
  }

  openDialog() {
    this.dialog.open(HashtutorialComponent);
  }

  viewLimit(value:number) {
    if (value === 0) {
      return '關閉';
    }
    if (value === 1) {
      return '低';
    }
    if (value === 2) {
      return '中';
    }
    if (value === 3) {
      return '高';
    }
    if (value === 4) {
      return '極高';
    }
  }

  alertcopy() {
    this._snackBar.open('已經複製到剪貼簿', '關閉', {
      duration: 2000,
      panelClass: 'copyalert',
    });
  }

  goToLogin(): void {
    alert('帳號錯誤');
    this.routerService.GoToHomePage();
  }
}
